import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import useCallNumbersPopover from 'call-widget-addon/useCallNumbersPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon } from 'foundations-assets';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useThirdPartyNumbersPopover } from 'calling-integration-help-desk/help-desk/hooks/useThirdPartyNumbersPopover';
import { getAuthAsPojo } from 'conversations-thread-data/auth/public/selectors';
import { useThreadListMemberDetails } from 'conversations-thread-data/thread-details/public/hooks';
import { useSelector } from 'react-redux';
import { THIRD_PARTY, STANDALONE, WIDGET } from '../constants/callingSource';
import { useLastPhoneNumber } from '../utils/useLastPhoneNumber';
import { useVisitorPhoneNumber } from '../utils/useVisitorPhoneNumber';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallingTab = ({
  closeDropdown,
  isKnownVisitor,
  subjectId,
  callingSource,
  associatedObjectId,
  associatedObjectTypeId,
  inboxId,
  threadId
}) => {
  const auth = useSelector(getAuthAsPojo);
  const defaultFromNumber = useLastPhoneNumber({
    threadId
  });
  const visitorPhoneNumber = useVisitorPhoneNumber({
    threadId
  });
  const appIdentifier = callingSource === STANDALONE || callingSource === THIRD_PARTY ? 'help desk' : 'inbox';
  const {
    data
  } = useThreadListMemberDetails({
    threadId
  });
  const ticketId = data && data.associatedTicketIds && data.associatedTicketIds[0];
  const callNumbersPopoverProps = {
    subjectId: `${associatedObjectId && associatedObjectTypeId ? associatedObjectId : subjectId}`,
    objectTypeId: associatedObjectTypeId && associatedObjectId ? associatedObjectTypeId : CONTACT_TYPE_ID,
    onCallButtonClick: closeDropdown,
    shouldFetch: true,
    appIdentifier,
    inboxId,
    threadId,
    ticketId,
    defaultFromNumber,
    isKnownVisitor,
    visitorPhoneNumber,
    auth
  };
  const [renderedCallNumbersPopover] = useCallNumbersPopover(callNumbersPopoverProps);
  const {
    renderedThirdPartyNumbersPopover,
    isThirdPartyCallingPopoverInUse
  } = useThirdPartyNumbersPopover(callNumbersPopoverProps);
  const showThirdPartyNumbersPopover = appIdentifier === 'help desk' && isThirdPartyCallingPopoverInUse;
  return /*#__PURE__*/_jsx(Dropdown, {
    "data-selenium-test": "editor-channel-dropdown-calling",
    buttonUse: "transparent",
    placement: "right bottom",
    caretRenderer: /*#__PURE__*/_jsx(RightIcon, {}),
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.tabbed-editor.calling-tab.button-text"
    }),
    children: callingSource === WIDGET && !isKnownVisitor ? /*#__PURE__*/_jsx(View, {
      maxInlineSize: "400px",
      padding: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.tabbed-editor.calling-tab.requires-associated-visitor"
      })
    }) : showThirdPartyNumbersPopover ? renderedThirdPartyNumbersPopover : renderedCallNumbersPopover
  });
};
CallingTab.displayName = 'CallingTab';